import { IConfig } from 'unleash-proxy-client';

export const environment = {
	production: false,
	url: 'https://api.develop.zenklub.com/',
	speechToTextUrl:
		'wss://services.develop.zenklub.com/pythia/stt/listen?token=D5658A-81D6F4-990E1D',
	websiteurl: 'https://webapp.develop.zenklub.com/',
	officeUrl: 'https://office.develop.zenklub.com/',
	typeformUrl:
		'https://zenklub.typeform.com/to/MoHDU1?source=zenoffice&userid={userId}&eventid={eventId}',
	speedTestServer: {
		name: 'Zenklub Speed Test',
		server: 'https://speedtest.zenklub.com/',
		dlURL: 'garbage.php?cors=true',
		ulURL: 'empty.php?cors=true',
		pingURL: 'empty.php?cors=true',
		getIpURL: 'getIP.php?cors=true',
	},
	firebase: {
		apiKey: 'AIzaSyAewAUdpYs3JNBfC-59-kqT-urX7Y7IxbI',
		authDomain: 'zenklub-ec35b.firebaseapp.com',
		databaseURL: 'https://zenklub-ec35b.firebaseio.com',
		projectId: 'zenklub-ec35b',
		storageBucket: 'zenklub-ec35b.appspot.com',
		messagingSenderId: '518915937528',
		appId: '1:518915937528:web:5e9ab3136f8247ab',
	},
	google: {
		tagManagerId: 'GTM-TJ3FL4K',
		recaptcha: '6LchH-wnAAAAACpRvYjhSSAXCbIeUToE77z-1j6D',
	},
	maxProfessionalComplaints: 8,
	maxProfessionalSpecialties: 3,
	sentry: {
		dsn: 'https://cab4042493114d4d9e29fe7873ec73f5@sentry.io/1870561',
		environment: 'develop',
		active: false,
	},
	talkjs: {
		appId: 'ts1owFVS',
	},
	stripe: {
		websiteurl: 'https://dashboard.stripe.com/',
		refreshUrl:
			'https://office.develop.zenklub.com/account/payment?refresh=true',
		returnUrl: 'https://office.develop.zenklub.com/account/payment?return=true',
		keys: {
			br: {
				publishableKey: 'pk_test_qR2i2egu6kRauLFDea7zZeMe',
				readkey: 'sk_test_7UJqY5J0kS5MOBMK07qUwLQX',
			},
			pt: {
				publishableKey: 'pk_test_EguVnHBnFzANUpu2scB2WQOz',
				readkey: 'sk_test_dI1WpCkiZOjmfI66mUgscbf3',
			},
		},
		apiVersion: '2020-08-27',
	},
	jitsi: {
		domain: 'jitsi.zenklub.com',
	},
	rabbitmq: {
		server: 'wss://services.develop.zenklub.com/ws',
		login: 'agentdev',
		password: '3nkC8sZBMT',
		virtualHost: 'develop',
		toppics: {
			appointments: '/topic/appointment.',
			financial: '/topic/professionals.financial.',
			accountValidation: '/topic/professionals.accountValidation.',
		},
	},
	checkout: {
		url: 'https://services.develop.zenklub.com/checkout/ebanx/payment',
		returnUrl: 'https://office.develop.zenklub.com/account/premium?return=true',
	},
	servicesUrl: 'https://services.develop.zenklub.com',
	microservices: {
		professional: { url: 'https://services.develop.zenklub.com/professional' },
	},
	memedIntegration: {
		scriptUrl:
			'https://integrations.memed.com.br/modulos/plataforma.sinapse-prescricao/build/sinapse-prescricao.min.js',
	},
	unleash: {
		clientKey:
			'*:development.df2c0d492748fb63fb473f863fb1cbaa93f967eb63f889bd81b79f02',
		url: 'https://unleash.dev.zenklub.com/api/proxy',
		appName: 'ZenOffice',
		environment: 'development',
	} as IConfig,
	usetifulToken: '9ee164506556b11c8d9c2f1f36b132c7',
	superset: {
		domain: 'https://superset.conexasaude.com.br/',
		dashboards: {
			financialReport: {
				id: '49594936-67f4-46f1-8d0d-c0926ce592ce',
				hideFilters: false,
			},
			financialReportNoCop: {
				id: '5f3b1aa7-4f20-4c84-a5c1-21bc48362ec1',
				hideFilters: false,
			},
			performance: {
				id: 'ed7edf57-a103-4a7d-b326-e204b4995a74',
				hideFilters: true,
			},
			contacts: {
				id: 'd31423c0-7ed2-4a7b-b9a5-ab2f3f5840d5',
				hideFilters: true,
			},
		},
	},
};
